import { useQuery } from "@tanstack/react-query";
import { akitaFetch, retry } from "data/akita-fetch";
import { GetTeamResponse } from "types/akita_api_types";

const getOrganizationMembers = () => akitaFetch<GetTeamResponse>("/organization/members");

export const useOrganizationMembers = () =>
  useQuery(["organization-members"], getOrganizationMembers, { retry });
